import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "@ramudden/services";

@Injectable({
    providedIn: "root",
})
export class PersistFiltersService {
    private readonly localStorageServie = inject(LocalStorageService);
    private readonly router = inject(Router);

    private readonly baseKey = "persist-filters";

    private getKey(): string {
        const componentKey = this.router.url.substring(1).replace(/\//g, "-").split("?")[0];
        return `${this.baseKey}.${componentKey}`;
    }

    public reset(): void {
        this.localStorageServie.removeItem(this.getKey());
    }

    public get(): any {
        return JSON.parse(this.localStorageServie.getItem(this.getKey()) ?? "{}");
    }

    public getAsString(): string {
        return this.localStorageServie.getItem(this.getKey()) ?? "{}";
    }

    public set(value: Record<string, string | boolean>): void {
        this.localStorageServie.setItem(this.getKey(), JSON.stringify(value));
    }

    public setFromString(value: string): void {
        this.localStorageServie.setItem(this.getKey(), value);
    }
}
